<template>
  <SingleCard>
    <template #title>
      Create your account
    </template>
    <template #body>
      <ValidationObserver ref="form" slim>
        <VForm>
          <VLayout row>
            <TextFieldWithValidation
              v-model="email"
              rules="required|email"
              label="Enter your email"
              name="email"
              autocomplete="email"
              type="email"
              @keyup.enter="create"
            />
          </VLayout>
          <VLayout row>
            <TextFieldWithValidation
              v-model="fullName"
              rules="required|alpha_spaces"
              label="Full Name"
              name="fullName"
              autocomplete="full-name"
              @keyup.enter="create"
            />
          </VLayout>
          <VLayout row>
            <TextFieldWithValidation
              v-model="password"
              rules="required"
              label="Password"
              name="password"
              vid="password"
              autocomplete="current-password"
              type="password"
              @keyup.enter="create"
            />
          </VLayout>
          <VLayout row>
            <TextFieldWithValidation
              v-model="passwordConfirm"
              rules="required|confirmed:password"
              label="Confirm Password"
              name="passwordConfirm"
              autocomplete="current-password"
              type="password"
              @keyup.enter="create"
            />
          </VLayout>
          <VLayout row class="info-policy">
            By clicking to create, you agree to our terms and conditions.
          </VLayout>
          <recaptcha @success="console.log('fff')"></recaptcha>
        </VForm>
      </ValidationObserver>
    </template>
    <template #actions>
      <VLayout wrap px-4>
        <VFlex>
          <VBtn
            :disabled="submitting"
            :loading="submitting"
            color="#4D5CD9"
            ripple
            block
            dark
            width="180"
            height="60"
            @click="create"
          >
            Create your account
          </VBtn>
        </VFlex>
      </VLayout>
    </template>
    <template #under-card>
      Already have an account?
      <nuxt-link :to="{ name: 'auth-login' }">Sign in.</nuxt-link>
    </template>
  </SingleCard>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import SingleCard from '~/components/base/SingleCard'
import TextFieldWithValidation from '~/components/TextFieldWithValidation'
import graphql from '~/gql'

export default {
  name: 'CreateAccountForm',
  components: {
    SingleCard,
    TextFieldWithValidation,
    ValidationObserver
  },
  data: () => ({
    email: '',
    fullName: '',
    password: '',
    passwordConfirm: '',
    submitting: false
  }),
  methods: {
    async create() {
      try {
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          try {
            const token = await this.$recaptcha.execute('login')
            try {
              const res = await this.$apollo.mutate({
                mutation: graphql.register.registerUser,
                variables: {
                  createUserInput: {
                    email: this.email,
                    name: this.fullName,
                    password: this.password
                  }
                }
              })
              this.$router.push({name: 'auth-create-success' })
            } catch (e) {
              console.error(e)
            }
            console.log('ReCaptcha token:', token)
          } catch (error) {
            console.log('Login error:', error)
          }
        }
      } catch (error) {
        console.log('Validation error:', error)
      }
    }
  }
}
</script>
<style scoped>
.info-policy {
  font-size: 12px;
}
.card-under {
  font-size: 20px;
}
</style>
